module.exports = __webpack_public_path__ + "img/appAsset--customer-contact-ax.768409d9.svg";